<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'checklist-fill',
    subject: 'Mfk',
  },
})

const page = {
  groupTitle: 'Fasilitas (MFK)',
  icon: 'ri-fire-line',
  color: 'secondary',
  title: 'Checklist MFK (APAR, Genset, dst.)',
  description: 'Mengisi checklist fasilitas — temuan "Tidak" otomatis membuat Task tindak lanjut.',
  purpose: 'Panduan mengisi checklist inspeksi fasilitas (Manajemen Fasilitas & Keselamatan), dan apa yang terjadi kalau ada temuan.',
  concept: [
    {
      icon: 'ri-checkbox-circle-line',
      title: 'Cara Isi Sama Seperti Checklist Biasa',
      text: 'Checklist MFK diisi persis seperti checklist lain — bedanya ada di belakang layar: kalau Anda menjawab "Tidak" pada satu item, sistem otomatis membuat Task tindak lanjut untuk Anda sendiri.',
    },
  ],
  steps: [
    { title: 'Buka menu Fasilitas → Checklist MFK', detail: 'Pilih template (mis. "Checklist APAR", "Checklist Genset").' },
    { title: 'Isi setiap item — jawab jujur sesuai kondisi sebenarnya', detail: 'Jangan menjawab "Ya" kalau kenyataannya bermasalah, meski tergoda untuk "aman" di laporan.' },
    { title: 'Klik "Simpan"', detail: 'Kalau ada jawaban "Tidak", Task tindak lanjut otomatis dibuat dengan Anda sebagai PIC dan tenggat 7 hari.' },
    { title: 'Cek "Task Saya" untuk melihat tindak lanjut yang perlu dikerjakan', detail: 'Task itu bisa dialihkan ke orang lain kalau bukan Anda yang seharusnya menangani.' },
  ],
  warning: 'Jawaban "Tidak" pada checklist ini membuat Task otomatis — jangan menjawab asal supaya terlihat baik, karena justru menyembunyikan masalah yang seharusnya ditindaklanjuti.',
  tips: [
    'Foto kondisi sebenarnya lewat lampiran Evidence begitu checklist tersimpan, terutama untuk temuan yang perlu tindak lanjut.',
  ],
  faq: [
    { q: 'Siapa yang jadi PIC Task otomatis dari temuan checklist?', a: 'Secara default, orang yang mengisi checklist itu sendiri — karena dialah yang ada di lokasi dan tahu detail masalahnya. Bisa dialihkan ke orang lain lewat "Reassign".' },
  ],
  related: [
    { title: 'Kalibrasi Alat Kesehatan', sub: 'Pengingat kalibrasi alat', icon: 'ri-tools-line', color: 'secondary', to: { name: 'help-fasilitas-kalibrasi-alat' } },
    { title: 'Task & Tindak Lanjut', sub: 'Menyelesaikan Task hasil temuan', icon: 'ri-task-line', color: 'primary', to: { name: 'help-mutu-task-tindak-lanjut' } },
  ],
}
</script>

<template>
  <GuidePageLayout v-bind="page" />
</template>
